import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { IQuestion } from '../../../../interfaces/question.interface';

@Component({
  selector: 'app-camera-answer',
  templateUrl: './camera-answer.component.html',
  styleUrls: ['./camera-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CameraAnswerComponent {
  @Input() question: IQuestion;
  @Input() count: number | null = null;
  @Input() withComment = false;
  form = this.fb.group({
    value: null,
  });
  constructor(private fb: UntypedFormBuilder) {}
}
